var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArkansas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.352,70.44c0,0-1.666-7.497,0-7.917c1.668-0.416,12.08-9.164,10.833-12.08c-1.251-2.917-5.417-7.498-5.417-7.498 l-108.522,3.953l-90.608,3.3v1.077l2.636,7.915l2.365,7.083v9.179v16.232l4.162,23.746v96.932c2.492,1.281,4.258,1.842,4.791,1.178 c2.501-3.125,15.623,0,15.623,0l1.107,31.043l133.87-3.34c4.583-6.248,2.92-10.831,0.836-16.664 c-2.086-5.833-3.751-15.832-3.751-15.832l4.581-22.912c4.169,0.832,4.583-7.916,5-10.831c0.419-2.915,12.913-14.995,14.166-15.413 c1.248-0.42,0-9.166,0-9.166s2.082-4.165,3.333-8.332c1.248-4.166,8.33-7.914,10.413-8.749c2.084-0.834,0-7.499,0-7.499l8.747-7.081 c0,0-3.748-17.914-4.372-19.58c-0.628-1.666,11.456-1.251,11.456-3.335c0-2.08,6.249-25.41,6.249-25.41H227.352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkansas);
export default __webpack_public_path__ + "static/media/arkansas.52907675634d1d77c53bedf33636e718.svg";
export { ForwardRef as ReactComponent };